"use strict"

import { EnvStage } from "common-library/ucountit-env"
import { createApiUrls } from "./apiurls"
import { Optional, Required } from "./Environment"

const hostname = "dev.retailanalysis.cloud"
const config: EnvStage<Required, Optional> = {
  port: 19500,
  brand: "development",
  host: [hostname],
  api: Object.assign(createApiUrls(hostname), {
    ioturl: "http://iot-dev.retailanalysis.cloud:19503/local-api/1.0/iot",
    faceurl: "http://secure-dev.retailanalysis.cloud:19509/api/v1",
    rebuildurl: "http://172.17.0.1:19620/api/v1",
    notiIoUrl: "http://secure-dev.retailanalysis.cloud:19640/api",
    spiderurl: "http://secure-dev.retailanalysis.cloud:19680/api",
  }),

  web: {
    faceurl: "/facedashboard",
    tunnelUrl: "http://tunnel.retailanalysis.cloud",
  },

  log: {
    analyticTrackingId: "G-XNC0EH31YX",
  },

  s3: {
    static: {
      bucket: "ucount-it.stage",
      destination: hostname + "/static",
      region: "us-west-1",
      cloudfront: "",
    },
    firmware: {
      bucket: "ucount-it.stage",
      destination: hostname + "/firmware",
      region: "us-west-1",
    },
    face: {
      bucket: "ucount-it.stage",
      destination: hostname + "/faces",
      region: "us-west-1",
    },
    customAgency: {
      bucket: "ucount-it.stage",
      destination: hostname + "/customAgency",
      region: "us-west-1",
    },
  },

  email: {
    from: "notification@ucountit.com",
  },

  cloudFront: {
    bucket: "ucount-it.static",
    region: "us-west-1",
    prefix: "ui-dev",
    basePath: "https://cdn.retailanalysis.cloud",
  },
}

export default config
